module.exports = __webpack_public_path__ + "img/img_11.8fb191b1.png";